import {useEffect} from "react";
import {Consts} from "./consts";

const Pdir = ({ studyBranch, userName }) => {
    const rect = document.body?.getBoundingClientRect();
    const width = rect.width > 0 ? rect.width : 1000;
    const height = rect.height > 0 ? rect.height * 0.9 : 1000;
    // tool 1: http://139.91.210.31/ --> https://safepolymedpdir.ics.forth.gr/
    // "http://195.251.199.65:8180/runquerydata/" - another tool of FORTH https://me.preciouscloud.eu:8443/runquerydata/

    useEffect(() => {
        const storeUserData = () => {
            const data = { studybranch: studyBranch, username: userName };
            const iframe = document.getElementById(Consts.API_IFRAME);

            iframe.onload = () => {
                iframe.contentWindow.postMessage(data, "*"); // Nachricht an das Iframe senden
            };
        };

        const loadIframe = () => {
            document.getElementById(Consts.API_IFRAME).src =
                "https://safepolymedpdir.ics.forth.gr/";
        };

        loadIframe();
        storeUserData();
    }, []);

    return (
        <div className="content-container">
            <div className="pdir-content">
                <iframe
                    id={Consts.API_IFRAME}
                    width={width}
                    height={height}
                    allowFullScreen
                ></iframe>
            </div>
        </div>
    );
};

export default Pdir;